import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Combine class names with two specific properties we want everywhere:
 *
 * 1. clsx handles conditional class arrays / objects (the standard
 *    React pattern: `cn('btn', isPrimary && 'btn-primary')`)
 * 2. twMerge deduplicates conflicting Tailwind classes — so
 *    `cn('px-2 py-1', 'px-4')` collapses to `'py-1 px-4'`.
 *
 * Without twMerge, variant props that override defaults produce broken
 * cascades like `'px-2 px-4'` where the last one only wins by source
 * order (which is brittle). With twMerge, the last px-* wins
 * deterministically.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map